import styled from 'styled-components'

export const HomeWrapperd = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .container {
        width: 50%;
        height: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .header{
            text-align: center;
            .logo {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
            }
            
        }
        .title {
                margin-top: 20px;
                font-size: 16px;
                font-weight: 400;
            }
        }
        .button {
            background: #07c160;
            padding: 5px 8px;
            border-radius: 2px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`